export const FETCH_ORDER_PENDING = "FETCH_ORDER_PENDING";
export const FETCH_ORDER_REJECTED = "FETCH_ORDER_REJECTED";
export const FETCH_ORDER_FULFILLED = "FETCH_ORDER_FULFILLED";
export const RESET_ORDER = "RESET_ORDER";



// WEBPACK FOOTER //
// ./src/constants/orderSearch.js